export default __webpack_public_path__ + "static/media/subscribe.326ba178.jpeg";